import { render, staticRenderFns } from "./Abandoned.vue?vue&type=template&id=1d73e0d8&scoped=true"
import script from "./Abandoned.vue?vue&type=script&lang=js"
export * from "./Abandoned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d73e0d8",
  null
  
)

export default component.exports